import * as React from 'react';
import DescriptionIcon from '@material-ui/icons/Description';
import { Linked, useModel } from '@type-r/react';
import { asCurrency, asDate, CompactTextArea, div, PopupIODialog, SelectFile, colors } from 'lqx-react';
import { InvoiceModel } from 'api/invoice';
import { ReadOnly } from 'lqx-react/src';
import { attributes, Events } from '@type-r/models';
import { SmallBox } from '../../inmatch/invoices/invoicesList';
import { makeStyles, styled } from '@material-ui/core';

const LocalState = attributes({
    comment: String,
    file: null
});

export const CloseInvoicesDialog = ({ $isOpen, invoices }: { $isOpen: Linked<boolean>, invoices: InvoiceModel[] }) => {
    let state = useModel(LocalState);
    let styles = useStyles();
    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title={"Close Invoices"}
            actionLabel={"Approve"}
            success={"Invoices Closed Succesfully"}
            onSuccess={ () => Events.trigger("Invoice:close") }
            doIO={ async () => {
                var data = invoices && invoices.length && invoices.map(x => x.id);
                await InvoiceModel.close(data);
            }}
        >
            <>
                <div className = { styles.h1 } > {invoices.length } <small>Invoices Selected</small></div>
                <div className = { styles.h2 } > {asCurrency(invoices.map(x => x.invoicedAmount).reduce((acc, amount) => acc + amount, 0))} </div>
                <br/>
                <ReadOnly.Provider value={true}>
                    <InvoicesContainer>
                        {
                            invoices.map(x => (
                                <SmallInvoiceTile key={x.cid}
                                    invoice={x}
                                />
                            ))
                        }
                    </InvoicesContainer>
                </ReadOnly.Provider>

                <CompactTextArea label="Comments"
                    $value={state.$.comment}
                />

                <SelectFile label="Attachment"
                    accept=".csv,.edi,.xml,.txt,.json,.pdf,.xls,.doc,.docx,.xlsx,.png,.jpeg"
                    $value={state.$.file}
                />
            </>
        </PopupIODialog>
    );
}

const SmallInvoiceTile = ({ invoice }: { invoice: InvoiceModel }) =>
    <SmallBox>
        <DescriptionIcon style={{ color: colors.green }} />
        <BoldField >{invoice.invoiceNumber}</BoldField>
        <BoldBlueEndField>{asDate(invoice.invoiceDueDateUtc)}</BoldBlueEndField>
        <BoldBlueEndField>{asCurrency(invoice.invoicedAmount)}</BoldBlueEndField>
    </SmallBox>

const useStyles = makeStyles({
    h1: {
        fontFamily: 'Montserrat',
        fontSize: 20,
        fontWeight: 500,
        color:'#052C4C'
    },
    h2:{
        fontFamily: 'Montserrat',
        fontSize: 14,
        fontWeight: 600,
        color:'#052C4C'
    }
});

const InvoicesContainer = div({
    display: "flex",
    flexDirection: "column",
    maxHeight: 200,
    overflowY: "auto"
})

const BoldField = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 8,
    paddingRight: 8,
    minWidth: '14em',
    fontSize: 12,
    fontWeight: 600,
    color: 'black'
});

const BoldBlueEndField = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 8,
    paddingRight: 8,
    minWidth: '14em',
    fontSize: 12,
    fontWeight: 600,
    color: '#1084D3',
    justifyContent: 'flex-end'
});
